<template>
  <div  class="columns is-marginless is-paddingless section section-details">
    <div class="column p-0 is-10">
      <div class="columns is-multiline is-marginless is-paddingless">
        <section class="column is-12" id="generalInformations">
          <div class="card">
            <header class="header-card">
              <p> {{ $t('detailFournisseurs.informationsGenerales.title')}} </p>
            </header>
            <info-generales :fournisseur="fournisseur"
              :isFactor="isFactor"
              :isService="isService"></info-generales>
          </div>
        </section>
        <section class="column is-12" id="contacts">
          <div class="card">
            <header class="header-card">
              <p> {{ $t('detailFournisseurs.contacts.title')}} </p>
            </header>
            <app-contacts :tier="fournisseur"></app-contacts>
          </div>
        </section>
        <section v-if="isFactor" class="column is-12">
          <div class="card" id="comments">
            <header class="header-card">
              <p> {{ $t('detailFournisseurs.commentaires.titleFactor')}} </p>
            </header>
            <div class="card-content has-text-default is-size-7">
              <span v-html="fournisseur.commentaireFactor"></span>
            </div>
          </div>
        </section>
        <section class="column is-6" id="comments">
          <div class="card height-100">
            <header class="header-card">
              <p> {{ $t('detailFournisseurs.commentaires.title')}} </p>
            </header>
            <div class="card-content has-text-default is-size-7">
              {{ fournisseur.commentairesInternes}}
            </div>
          </div>
        </section>
        <section class="column is-6" id="infoComptables">
          <div class="card height-100">
            <header class="header-card">
              <p> {{ $t('detailFournisseurs.infoCompta.title')}} </p>
            </header>
            <info-comptable :fournisseur="fournisseur"></info-comptable>
          </div>
        </section>
        <section class="column is-12" id="attachments">
          <div class="card">
            <header class="header-card">
              <p> {{ $t('detailFournisseurs.piecesJointes.title')}} </p>
            </header>
            <div class="card-content">
              <pieces-jointes
                :checkPermissions="checkPermissions(permission.maj)"
                readOnly deletable autoSave
              />
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="column p-0 is-2">
      <div class="is-fixed mgt-20px">
        <dots-menu :steps="steps"></dots-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import DotsMenu from '@/components/general/dotsMenu';
import AppContacts from '@/components/tiers/contacts/contacts';
import PiecesJointes from '@/components/general/piecesJointes';
import InfoGenerales from '@/components/commun/fournisseur/detailFournisseur/infoGenerales';
import InfoComptable from '@/components/achat/fournisseurs/detail/informationsTab/inforComptableFournisseurs';
import { FOURNISSEURS } from '@/configuration/achat/permissionsConf';
import { TIERS_SOUS_TYPE_FACTOR, TIERS_SOUS_TYPE_SERVICE } from '@/configuration/tiers/tiersConf';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'DetailFournisseursInformationsTab',
  components: {
    DotsMenu,
    AppContacts,
    PiecesJointes,
    InfoGenerales,
    InfoComptable,
  },
  props: {
    fournisseur: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permission: FOURNISSEURS,
      steps: [
        {
          name: this.$i18n.t('detailFournisseurs.steps.infoGenerales'),
          ref: '#generalInformations',
          active: true,
        },
        {
          name: this.$i18n.t('detailFournisseurs.steps.contacts'),
          ref: '#contacts',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseurs.steps.infoComptables'),
          ref: '#bankDetails',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseurs.steps.commentaires'),
          ref: '#comments',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseurs.steps.piecesJointes'),
          ref: '#attachments',
          active: false,
        },
      ],
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    isFactor() {
      return this.isType(TIERS_SOUS_TYPE_FACTOR);
    },
    isService() {
      return this.isType(TIERS_SOUS_TYPE_SERVICE);
    },
  },
  methods: {
    isType(type) {
      return this.fournisseur.sousTypes.some((el) => el === type);
    },
  },
};
</script>
